var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import parse from 'html-react-parser';
var Address = function (prop) {
    return (prop.data && (_jsx("div", __assign({ className: "address text-[14px] md:text-[14px] leading-[1.5]" }, { children: parse(prop.data) }), void 0)));
};
export default Address;
